import React from 'react';
import { Link, Navigate, useLocation } from 'react-router';
import { BRAND } from '../brand.ts';
import HomeBackdrop from './HomeBackdrop.tsx';
import '@fontsource-variable/unbounded';
import './pages.css';

export default function HomePage() {
  const location = useLocation();

  // Links shared before the router existed point at / with the model state in
  // the hash; send them to the workspace with the hash preserved.
  if (location.hash.length > 1) {
    return <Navigate to={`/studio${location.hash}`} replace />;
  }

  return (
    <div className="home-page">
      <div className="home-scene">
        <div className="home-glow" aria-hidden="true" />
        <HomeBackdrop />
      </div>

      <main className="home-hero">
        <h1 className="home-logo">
          <span className="home-logo-text">{BRAND.name}</span>
        </h1>

        <Link className="home-cta" to="/studio">
          <span>Open the studio</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M2 8h11.5M8.5 3.5 13 8l-4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      </main>
    </div>
  );
}
